import React from 'react'
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { Stack } from '@mui/material';
import { customStyles } from '../../../styles';
import { SubTitle } from '../../helpers';
export const NoAccounts = () => {
  return (
    <Stack spacing={3} alignItems="center" justifyContent="center" width="100%" height="70vh">
      <ImportContactsIcon sx={{ color: customStyles.colors.main, fontSize: 80, }}/>
      <SubTitle text="No hay direcciones registradas" color={customStyles.colors.main}/>
    </Stack>
  )
}
